console.log("Assistant Taxonomy Loaded");

const PRODUCT_FAMILIES = {

    CCTV: {
        include: [
            "cctv",
            "security camera",
            "wifi camera",
            "ip camera",
            "ptz",
            "bullet",
            "bulb camera",
            "dual lens",
            "outdoor camera",
            "indoor camera",
            "4g camera",
            "floodlight camera",
            "baby monitor"
        ],
        exclude: [
            "spy",
            "hidden",
            "pen",
            "usb",
            "glasses",
            "charger camera"
        ]
    },

    HIDDEN_CAMERA: {
        include: [
            "spy",
            "hidden",
            "pen camera",
            "usb camera",
            "camera glasses",
            "charger camera",
            "mini camera"
        ],
        exclude: []
    },

    DASH_CAMERA: {
        include: [
            "dash camera",
            "dashcam",
            "car camera"
        ],
        exclude: []
    },

    FINGERPRINT_LOCK: {
        include: [
            "fingerprint",
            "smart lock",
            "padlock",
            "door lock",
            "cabinet lock",
            "glass door lock"
        ],
        exclude: []
    },

    GPS: {
        include: [
            "gps",
            "tracker"
        ],
        exclude: []
    },

    VIDEO_DOORBELL: {
        include: [
            "doorbell"
        ],
        exclude: []
    },

    SMART_BULB: {
        include: [
            "smart bulb"
        ],
        exclude: []
    },

    SMART_SWITCH: {
        include: [
            "smart switch"
        ],
        exclude: []
    },

    SMART_SENSOR: {
        include: [
            "sensor",
            "motion sensor",
            "gas detector",
            "smoke detector",
            "door sensor",
            "window sensor"
        ],
        exclude: []
    },

    SOLAR: {
        include: [
            "solar",
            "power station"
        ],
        exclude: []
    },

    WASHROOM: {
        include: [
            "tap",
            "faucet",
            "washroom",
            "toilet",
            "bidet",
            "soap dispenser",
            "flush"
        ],
        exclude: []
    }

};

function detectProductFamily(product){

    const text = (

        product.title + " " +

        (product.product_type || "") + " " +

        (Array.isArray(product.tags)
            ? product.tags.join(" ")
            : product.tags || "")

    ).toLowerCase();

    for(const family in PRODUCT_FAMILIES){

        const rule = PRODUCT_FAMILIES[family];

        const matched = rule.include.some(word =>
            text.includes(word)
        );

        if(!matched){
            continue;
        }

        const excluded = rule.exclude.some(word =>
            text.includes(word)
        );

        if(excluded){
            continue;
        }

        return family;

    }

    return "OTHER";

}